import { combineReducers } from 'redux';
import fetchExtractReducer from 'redux/Reducers/Extract/Reducer';
import totalizersReducer from 'redux/Reducers/Extract/TotalizersReducer';
import pointsExpireReducer from 'redux/Reducers/Extract/PointsExpireReducer';
import creditToExpireReducer from 'redux/Reducers/Extract/CreditToExpireReducer';
import fetchExtractCampaignNameReducer from 'redux/Reducers/Extract/CampaignNameReducer';

const ExtractReducer = combineReducers({
  totalizers: totalizersReducer,
  pointsExpire: pointsExpireReducer,
  creditToExpire: creditToExpireReducer,
  items: fetchExtractReducer,
  campaign: fetchExtractCampaignNameReducer,
});

export default ExtractReducer;
